import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import type { UserEmailSettingGroupedMap } from 'components/email-notification-setting/types';
import type { UpdateUserEmailSettingListType } from 'components/email-notification-setting/types';
import { classifyUserEmailSettingAlertOptions } from 'components/email-notification-setting/utils';
import useMounted from 'hooks/useMounted';
import {
  requestFinancierDealerUserEmailSettingList,
  requestFinancierDealerUserEmailSettingUpdate,
} from 'utils/http/api/financier/partner-users';
import useModal from 'utils/modal/useModal';
import { getFactoringEnable } from 'utils/storage/LocalStorage';

function useFinancierManageDealerUserDetailEmailSettingController() {
  const { userId } = useParams() as any;
  const factoringEnable = getFactoringEnable();
  const mounted = useMounted();
  const modal = useModal();

  const [selectedCommonAlertSetting, setSelectedCommonAlertSetting] = useState<UserEmailSettingGroupedMap | null>();
  const [selectedVendorAlertSetting, setSelectedVendorAlertSetting] = useState<UserEmailSettingGroupedMap | null>();
  const [selectedDealerAlertSetting, setSelectedDealerAlertSetting] = useState<UserEmailSettingGroupedMap | null>();

  useEffect(() => {
    if (mounted) {
      fetchEmailSetting();
    }
  }, [mounted]);

  const fetchEmailSetting = async (): Promise<void> => {
    try {
      const alertSettingResponse = await requestFinancierDealerUserEmailSettingList(userId);

      const { commonFormList, vendorFormList, dealerFormList } = classifyUserEmailSettingAlertOptions(
        alertSettingResponse,
        factoringEnable,
      );

      setSelectedCommonAlertSetting(commonFormList);
      setSelectedVendorAlertSetting(vendorFormList);
      setSelectedDealerAlertSetting(dealerFormList);
    } catch (error) {
      modal.show(error);
    }
  };

  const updateEmailSettingHandler = async (updateUserEmailSettingList: UpdateUserEmailSettingListType[]) => {
    try {
      const updatedAlertSettingResponse = await requestFinancierDealerUserEmailSettingUpdate(userId, {
        updateUserEmailSettingList,
      });

      const { commonFormList, vendorFormList, dealerFormList } = classifyUserEmailSettingAlertOptions(
        updatedAlertSettingResponse,
        factoringEnable,
      );

      setSelectedCommonAlertSetting(commonFormList);
      setSelectedVendorAlertSetting(vendorFormList);
      setSelectedDealerAlertSetting(dealerFormList);
    } catch (error) {
      modal.show(error);
    }
  };

  return {
    updateEmailSettingHandler,
    selectedCommonAlertSetting,
    selectedVendorAlertSetting,
    selectedDealerAlertSetting,
  };
}

export default useFinancierManageDealerUserDetailEmailSettingController;
